module.exports = __webpack_public_path__ + "img/text-loader-animation.00c36a52.svg";